import { BlogSection } from '@/types/blog';

export const fazit: BlogSection = {
  id: 'fazit',
  title: 'Rückverbindung: Der Weg zur authentischen Führung',
  content: `
<p class="mb-4">
  Vielleicht ist es Zeit zu hinterfragen, ob das Nischen-Dogma wirklich Ihrer Natur entspricht. Vielleicht liegt Ihr Wert nicht darin, der beste Bohrer für ein spezifisches Loch zu sein. Vielleicht liegt er darin, die Katalysator-Führungskraft zu sein, die das gesamte Ökosystem versteht und zum Blühen bringt.
</p>

<div class="bg-primary/10 p-6 rounded-xl border-l-4 border-primary mb-8 mt-6">
  <p class="text-lg font-medium italic">
    Das ist keine Schwäche. Das ist die logische Konsequenz, wenn Sie Ihre Natur nicht mehr unterdrücken, sondern als größte Stärke in den Dienst eines Systems stellen.
  </p>
</div>

<h3 class="text-xl font-semibold mt-8 mb-4">Wie ich Ihnen helfen kann</h3>

<p class="mb-4">
  Falls Sie erkunden möchten, ob Katalysator-Führung zu Ihrem Kontext passt, oder wenn Sie Ihre Führung auf wissenschaftlich fundierter Basis weiterentwickeln wollen – ich begleite Menschen an genau diesen Schnittstellen. Nicht mit vorgefertigten Rezepten, sondern im gemeinsamen Erforschen dessen, was in Ihrem spezifischen System wirksam werden kann.
</p>

<p class="mb-4">
  Mehr zu meiner Arbeitsweise finden Sie <a href="/executive-coaching" class="text-primary hover:underline font-medium">hier</a>.
</p>
  `,
};
